module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--8-c89f7a9a869963cc6e34f009b9898005.jpg";